"use client"

import { useEffect, useMemo, useState } from "react"
import styles from '../css/components/pagination.module.css'; 

export function Pagination({
  currentPage: initialPage = 1,
  totalPages: total = 1,
  onPageChange,
  pageWindow,
}) {
  const [currentPage, setCurrentPage] = useState(initialPage)

  // Keep internal state in sync with prop when parent updates it
  useEffect(() => {
    setCurrentPage(initialPage)
  }, [initialPage])

  const handlePageChange = (page) => {
    if (page < 1 || page > total) return
    setCurrentPage(page)
    if (onPageChange) onPageChange(page)
  }

  const pageNumbers = useMemo(() => {
    const before = pageWindow?.before ?? null;
    const after = pageWindow?.after ?? null;

    if (before === null || after === null) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const start = Math.max(1, currentPage - before);
    const end = Math.min(total, currentPage + after);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }, [currentPage, pageWindow?.before, pageWindow?.after, total]);

  return (
    <div className={styles.container}>
      <button
        className={styles.btn}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <svg className={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {pageNumbers.map((page) => (
        <button
          key={page}
          className={styles.btn}
          onClick={() => handlePageChange(page)}
          style={{
            backgroundColor: currentPage === page ? "#38BDF8" : "transparent",
            color: currentPage === page ? "#fff" : "#64748b",
          }}
        >
          {page}
        </button>
      ))}

      <button
        className={styles.btn}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === total}
      >
        <svg className={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  )
}

export default Pagination
